import { render, staticRenderFns } from "./PluginRatingStats.vue?vue&type=template&id=b2eee448&scoped=true"
import script from "./PluginRatingStats.vue?vue&type=script&lang=js"
export * from "./PluginRatingStats.vue?vue&type=script&lang=js"
import style0 from "./PluginRatingStats.vue?vue&type=style&index=0&id=b2eee448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eee448",
  null
  
)

export default component.exports